// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textoarriba{vertical-align:top}.tablaDiag{border:1px solid #ececec;border-spacing:.5rem;border-collapse:collapse}", ""]);
// Exports
module.exports = exports;
